namespace _Ext {
    @Serenity.Decorators.responsive()
    //@Serenity.Decorators.maximizable()
    export class BOMDialog<TEntity, TOptions>
        //this comment is for preventing replacement 
        extends Serenity.EntityDialog<TEntity, TOptions> {
        protected getRowType(): { idProperty?: string, localTextPrefix?: string, nameProperty?: string, insertPermission?: string, updatePermission?: string, deletePermission?: string, } { return {}; }
        protected getIdProperty() { return this.getRowType().idProperty; }
        protected getLocalTextPrefix() { return this.getRowType().localTextPrefix; }
        protected getNameProperty() { return this.getRowType().nameProperty; }
        protected getInsertPermission() { return this.getRowType().insertPermission; }
        protected getUpdatePermission() { return this.getRowType().updatePermission; }
        protected getDeletePermission() { return this.getRowType().deletePermission; }

        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }

        private loadedState: string;
        isReadOnly: boolean = false;
        protected form: any;

        constructor(opt?) {
            super(opt);
            //this.element.fadeTo(0, 0);

            if (this.get_ExtDialogOptions().PendingChangesConfirmation == true) {
                _Ext.DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
            }

            this.element.removeClass('ui-corner-all')
        }

        protected updateInterface() {
            super.updateInterface();

            //this.setReadOnly(this.isReadOnly);

            if (this.get_ExtDialogOptions().HideCategoyLinksBar == true) {
                this.element.find('.category-links').hide();

                let $FirstCategory = this.element.find('.first-category > .category-title');

                if (Q.isEmptyOrNull($FirstCategory.find('.category-anchor').text()))
                    $FirstCategory.hide();

            }

            //this.element.fadeTo(100, 1);
        }
        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.get_ExtDialogOptions().AutoFitContentArea == true) {
                this.fullContentArea();
            }

            //temporary fix for set grid editor height
            setTimeout(() => { this.onAfterSetDialogSize(); }, 200)

        }

        protected onDialogClose() {
            super.onDialogClose();

            this.onAfterDialogClose(this.getSaveEntity());
        }

        protected setReadOnly(value: boolean) {
            this.readOnly = value;
            this.isReadOnly = value;

            if (this.isReadOnly == true) {
                this.saveAndCloseButton.toggleClass('disabled', this.isReadOnly);
                this.applyChangesButton.toggleClass('disabled', this.isReadOnly);
                this.deleteButton.toggleClass('disabled', this.isReadOnly);
                this.cloneButton.toggleClass('disabled', this.isReadOnly);
                this.undeleteButton.toggleClass('disabled', this.isReadOnly);
                this.toolbar.findButton('btn-save-and-new').toggleClass('disabled', this.isReadOnly);
                this.toolbar.findButton('btn-replace-row').toggleClass('disabled', this.isReadOnly);
                this.toolbar.findButton('btn-history').addClass('disabled');
                this.toolbar.findButton('btn-custom').toggleClass('disabled', this.isReadOnly);

                // remove required asterisk (*)
                this.element.find('sup').toggle(this.isReadOnly);
                //for (let editor in this.form) {
                //    if (this.form[editor].widgetName) {

                //        try {
                //            Serenity.EditorUtils.setReadOnly(this.form[editor], this.isReadOnly);
                //        } catch{ }
                //    }
                //}

            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            let extOptions = this.get_ExtDialogOptions();

           // var savebtn = buttons.filter(x => x.cssClass == 'save-and-close-button')[0];
            //savebtn.icon = 'fa fa-save';
            if (extOptions.ShowApplyButton == true)
                buttons.push({
                    title: '',
                    hint: q.text('Controls.EntityDialog.ApplyChangesButton', 'Apply'),
                    //icon: 'fa fa-save',
                    cssClass: 'apply-button',
                    hotkey: 'alt+a',
                    onClick: () => {
                        this.OnApplybuttonClick();
                    },
                    visible: () => !this.isDeleted() && !this.isViewMode(),
                    disabled: () => !this.hasSavePermission() || this.readOnly
                });


            if (extOptions.ShowSaveAndNewButtonInToolbar == true)
                buttons.push({
                    title: q.text('Controls.EntityDialog.SaveAndNew', 'Save & New'),
                    icon: 'fa fa-save',
                    cssClass: 'btn-save-and-new',
                    onClick: () => {
                        this.onSaveAndNewButtonClick();
                    },
                    visible: () => !this.isDeleted() && !this.isViewMode(),
                    disabled: () => !this.hasSavePermission() || this.readOnly
                });

            if (extOptions.ShowCloseButtonInToolbar == true)
                buttons.push({
                    title: q.text('Controls.EntityDialog.Close', 'Close'),
                    icon: 'fa fa-close',
                    cssClass: 'btn-close',
                    onClick: () => {
                        this.dialogClose();
                    }
                });
            if (extOptions.ShowDeleteButton == false) {
                buttons = buttons.filter(x => x.cssClass != "delete-button");
            }
            if (extOptions.ShowApplyButton == true)
                buttons = buttons.filter(x => x.cssClass != "apply-button");
            if (extOptions.ShowSaveAndNewButtonInToolbar == true)
                buttons = buttons.filter(x => x.cssClass != "btn-save-and-new");

            if (extOptions.ShowRefreshButtonInToolbar == true)
                buttons.push({
                    title: q.text('Controls.EntityDialog.Refresh', 'Refresh'),
                    icon: 'fa fa-refresh',
                    onClick: () => {
                        this.onRefreshClick();
                    }
                });

            if (extOptions.ShowNextPreviousButton == true) {
                buttons.push({
                    title: "",
                    icon: "fa fa-step-backward",
                    cssClass: "btn-previous-record icon-tool-button text-purple",
                    visible: () => !this.isDeleted(),
                    onClick: () => {
                        let grid = this.parentGrid;
                        let self = this;
                        (function back(loadedNewPage?: boolean) {
                            let listIds = grid.view.getItems().map(x => x[(grid as any).getIdProperty()]);

                            if (grid !== null && typeof grid !== 'undefined') {
                                if (loadedNewPage) {
                                    let preId = listIds[listIds.length - 1];
                                    //this. entityOrId = preId;
                                    self.loadByIdAndOpenDialog(preId);
                                }
                                else {
                                    let currentEntityId = self.entityId;
                                    if (currentEntityId !== null && typeof currentEntityId !== 'undefined') {

                                        let currentIdIndex = listIds.indexOf(currentEntityId);
                                        if (currentIdIndex <= 0) {
                                            Q.notifyWarning("No More Records Found!")
                                            return;
                                        }
                                        else {
                                            let preId = listIds[currentIdIndex - 1];
                                            let preentity = Q.tryFirst(grid.view.getItems(), x => x[(grid as any).getIdProperty()] == preId);
                                            //self.loadByIdAndOpenDialog(nextId);
                                            self.loadEntityAndOpenDialog(preentity);
                                        }
                                    }
                                }
                            }
                        })();

                    }
                })

                buttons.push({
                    title: "",
                    icon: "fa fa-step-forward",
                    cssClass: "btn-next-record icon-tool-button text-purple",
                    visible: () => !this.isDeleted(),
                    onClick: () => {
                        let grid = this.parentGrid;
                        let self = this;
                        (function next(loadedNewPage?: boolean): void {
                            let listIds = grid.view.getItems().map(x => x[(grid as any).getIdProperty()]);

                            if (grid !== null && typeof grid !== 'undefined') {
                                if (loadedNewPage) {
                                    let nextId = listIds[0];
                                    self.loadByIdAndOpenDialog(nextId);
                                }
                                else {
                                    let currentEntityId = self.entityId;
                                    if (currentEntityId !== null && typeof currentEntityId !== 'undefined') {
                                        let listIds = grid.view.getItems().map(x => x[(grid as any).getIdProperty()]);

                                        let currentIdIndex = listIds.indexOf(currentEntityId);
                                        if (currentIdIndex >= listIds.length - 1) {
                                            Q.notifyWarning("No More Records Found!")
                                            return;
                                        }
                                        else {
                                            let nextId = listIds[currentIdIndex + 1];
                                            let nextentity = Q.tryFirst(grid.view.getItems(), x => x[(grid as any).getIdProperty()] == nextId);
                                            //self.loadByIdAndOpenDialog(nextId);
                                            self.loadEntityAndOpenDialog(nextentity)
                                        }
                                    }
                                }
                            }
                        })();

                    }
                })

            }

            try {
                if (extOptions.ShowReplaceRowButtonInToolbar == true && Q.Authorization.hasPermission('Administration:ReplaceRow')) {
                    if (Q.isEmptyOrNull(this.getService()) == false) {
                        buttons.push({
                            title: 'Replace',
                            icon: 'fa fa-trash-o',
                            cssClass: 'btn-replace-row',
                            onClick: () => {
                                let idProperty = this.getIdProperty();
                                let nameProperty = this.getNameProperty();
                                let entityId = this.entity[idProperty];
                                let entityName = this.entity[nameProperty];

                                if (entityId) {

                                    Q.serviceRequest(this.getService() + '/List', {}, (response: Serenity.ListResponse<any>) => {
                                        let entityList = response.Entities;

                                        let dlg = new ReplaceRowDialog({
                                            FormKey: this.getFormKey(),
                                            IdProperty: idProperty,
                                            NameProperty: nameProperty,
                                            EntityTypeTitle: this.getEntitySingular(),
                                            DeletedEntityName: entityName,
                                            DeletedEntityId: entityId,
                                        },
                                            entityList);

                                        dlg.dialogOpen();

                                        this.dialogClose();
                                    });
                                }
                            }
                        })
                    }


                }


                if (extOptions.ShowChangeLogButtonInToolbar == true && Q.Authorization.hasPermission('Administration:Security')) {

                    buttons.push({
                        cssClass: 'btn-history',
                        icon: 'fa fa-history',
                        onClick: () => {
                            let entityId = this.entity[this.getIdProperty()];
                            if (entityId) {
                                let dlg = new AuditLogViewerDialog({ FormKey: this.getFormKey(), EntityId: entityId });

                                dlg.dialogOpen();
                            } else {
                                Q.alert('No change log found for this voucher.')
                            }
                        }
                    });
                }

                //clone button click event customization
                let cloneButton = Q.tryFirst(buttons, x => x.cssClass == 'clone-button');

                cloneButton.onClick = () => {

                    if (!this.isEditMode()) {
                        return;
                    }

                    var cloneEntity = this.getCloningEntity();

                    Serenity.Widget.create({
                        type: (Q as any).getInstanceType(this),
                        init: (dlg: DialogBase<any, any>) => {
                            this.parentGrid.initDialog(dlg);
                            dlg.loadEntityAndOpenDialog(cloneEntity, null);
                        }
                    });

                    this.dialogClose();
                }
            } catch (e) { }

            return buttons;
        }

        protected onRefreshClick() {
            this.reloadById();
        }

        protected OnApplybuttonClick() {
            this.save(response => {

                if (this.isEditMode()) {
                    var id1 = response.EntityId;
                    if (id1 == null) {
                        id1 = this.get_entityId();
                    }
                    this.loadById(id1);
                }
                else {
                    this.loadById(response.EntityId);
                }
            });
        }

        protected onSaveAndNewButtonClick() {
            this.save(response => {
                this.loadEntity({} as any);
            });
        }

        protected getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);
            isPageRefreshRequired = true; 
        }

        loadResponse(data) {
            super.loadResponse(data);

            if (this.get_ExtDialogOptions().PendingChangesConfirmation == true) {
                this.loadedState = this.getSaveState();
                var t = this.loadedState;
            }
        }

        maximize() {
            this.element.closest(".ui-dialog").find(".ui-dialog-titlebar-maximize").click();

            setTimeout(() => {
                let dialogElement = this.element ? this.element.closest(".ui-dialog") : $(".ui-dialog");

                let dialogHeight = dialogElement.height();
                let titleBarHeight = dialogElement.find('.ui-dialog-title').height() || 20;

                let $categories = this.element.find('.categories');
                let categoriesTop = $categories.position().top;

                $categories.height(dialogHeight - titleBarHeight - categoriesTop - 20);

            }, 100);

        }

        fullContentArea() {
            this.setDialogSize();
        }
        // set the dialog size relative to content area (to shrink use negative value)
        setDialogSize(width?, height?, top?, left?, $content?) {
            if (!$content) {
                $content = $('section.content');

                //$content = $('s-Form');
            }
            if ($content.length == 0) {
                $content = $('.content-wrapper');
            }

            let dialogElement = this.element ? this.element.closest(".ui-dialog") : $(".ui-dialog");

            if ($content.length > 0 && dialogElement.length > 0) {

                let dialogWidth = $content.width() + 20 + (width || 0);
                let dialogHeight = $content.height() + (height || 10);
                let heights = dialogElement.height();
                let dwidth = dialogElement.width();

                //if (dialogWidth > dwidth)
                    this.element.dialog("option", "width", dialogWidth);
                //else
                //    this.element.dialog("option", "width", dwidth);
                this.element.dialog("option", "height", dialogHeight);
                //this.element.dialog("option", "height", heights)
                this.element.dialog("option", "position", "center")

                let titleBarHeight = dialogElement.find('.ui-dialog-title').height() || 20;

                let $categories = this.element.find('.categories');
                let categoriesTop = $categories.position().top;

                var t = $categories.height(dialogHeight - titleBarHeight - categoriesTop - 20);

               // $categories.height(dialogHeight - titleBarHeight - categoriesTop - 20);
                $categories.height(heights - titleBarHeight - categoriesTop - 20);

                dialogElement.css({
                    //left: $content.position().left + (left || 0),
                    //top: (top || 50),
                });
            }

            setTimeout(() => {
                this.onAfterSetDialogSize();
            }, 200);

        }

        onAfterSetDialogSize() { }
        onAfterDialogClose(entity: TEntity) { }



        parentGrid: GridBase<TEntity, any>;

        dataGrid: Serenity.DataGrid<any, any>;
    }
}